module.exports = "/wwwroot/img/listing_page.png?ver=b55b0ded";